import { render, staticRenderFns } from "./BookmarkCarousel.vue?vue&type=template&id=24380e52"
import script from "./BookmarkCarousel.vue?vue&type=script&lang=ts"
export * from "./BookmarkCarousel.vue?vue&type=script&lang=ts"
import style0 from "./BookmarkCarousel.vue?vue&type=style&index=0&id=24380e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports